import React from 'react';
import { cn } from '../../../lib/utils';
import { sidebarRailItemClass, sidebarRailWrapClass } from './sidebarDesign';

export interface AppSidebarRailButtonProps {
  label: string;
  active?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  badge?: number;
  children: React.ReactNode;
  buttonRef?: React.Ref<HTMLButtonElement>;
}

/** Collapsed sidebar icon control with active pill indicator. */
export const AppSidebarRailButton: React.FC<AppSidebarRailButtonProps> = ({
  label,
  active = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  badge,
  children,
  buttonRef,
}) => (
  <div
    className={sidebarRailWrapClass()}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <button
      ref={buttonRef}
      type="button"
      onClick={onClick}
      className={cn(sidebarRailItemClass(active))}
      aria-label={label}
      title={label}
    >
      <span className="flex items-center justify-center [&_svg]:h-[1.125rem] [&_svg]:w-[1.125rem]">
        {children}
      </span>
    </button>
    {badge ? (
      <span className="pointer-events-none absolute right-0 top-0 flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-semibold text-white">
        {badge > 9 ? '9+' : badge}
      </span>
    ) : null}
  </div>
);

export default AppSidebarRailButton;
